import Vue from 'vue';

export const OpenIndicator = Vue.component( 'OpenIndicator', {
	template: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M8.01 9.29l-4.3-4.3c-.3-.3-.8-.3-1.2 0-.3.3-.3.8 0 1.1l4.9 4.9c.3.3.8.3 1.2 0l4.9-4.9c.3-.3.3-.8 0-1.1s-.8-.3-1.2 0l-4.3 4.3z" fill="#de3c4b"/></svg>',
});



// WEBPACK FOOTER //
// ./assets/_js/mixins/open-indicator.js